var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70801 10.2917H12.6663M6.33301 10.2917H6.34012M10.2913 13.4583H6.33301M12.6663 13.4583H12.6592",
    stroke: "#3A86DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 1.58334V3.16668M4.75 1.58334V3.16668",
    stroke: "#3A86DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.97949 9.69253C1.97949 6.24304 1.97949 4.51826 2.97075 3.44663C3.96202 2.375 5.55742 2.375 8.74824 2.375H10.2524C13.4432 2.375 15.0387 2.375 16.0299 3.44663C17.0212 4.51826 17.0212 6.24304 17.0212 9.69253V10.0991C17.0212 13.5487 17.0212 15.2734 16.0299 16.3451C15.0387 17.4167 13.4432 17.4167 10.2524 17.4167H8.74824C5.55742 17.4167 3.96202 17.4167 2.97075 16.3451C1.97949 15.2734 1.97949 13.5487 1.97949 10.0991V9.69253Z",
    stroke: "#3A86DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 6.33334H16.625",
    stroke: "#3A86DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateCalendar);
export default __webpack_public_path__ + "static/media/date-calendar.f5ce4d91669265bf94d8b02474e0bf33.svg";
export { ForwardRef as ReactComponent };